export default __webpack_public_path__ + "static/media/welcome_header.98463f71.png";